import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map } from 'rxjs';
import { BulkMessageNotificationType } from 'src/app/enum/account-type';
import { CategoryType } from 'src/app/enum/change-request-status-type';
import { BulkMessageService } from 'src/app/services/bulk-message.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserdataService } from 'src/app/services/userdata.service';
import { environment } from 'src/environments/environment';
import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-messaging-add',
    templateUrl: './messaging-add.component.html',
    styleUrls: ['./messaging-add.component.scss']
})
export class MessagingAddComponent implements OnInit {
    displayedColumns: string[] = [
        'FirstName',
        'LastName',
        'Email',
        'MobileNumber',
        'ReferenceNumber',
    ];
    displayedColumns1: string[] = [
        'Action',
        'Name',
        'Email',
        'ContactNo',
        'CustomerNumber',
        'Address',

    ];
    data: any = []
    dataExcel: any = []
    dataSource: any = new MatTableDataSource(this.data);
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    searchform: any;
    groupForm: any;
    applicationStatusList: any = [];
    applicationStatus: any;
    serviceProviderList: any = [];
    provinceList: any = [];
    isReset: boolean;
    complexApplicationList: any = [];
    filteredList1: any
    filteredList2: any
    filteredList3: any
    filteredList4: any;
    complexList: any;
    applicationList: any = [];
    BulkMessageNotificationTypeEnum = BulkMessageNotificationType
    userdetailsForm: any;
    groupMessageForm: any
    userDetailsList: any[];
    selectedUser: number;
    singleMessageForm: any
    requestBank: any;
    categoryTypeEnum = CategoryType
    templateList: any;
    isDisableServiceProvider = false
    isDisableCity = false
    selectedComplexList: any;
    serviceProviderUserDetailsList: any;
    complex: any[];
    cityList: { key: unknown; value: unknown; }[];
    selectedSeviceProviderUserList: any;
    searchText: any
    messageList: any;
    messageCount = 0
    showmessage = false
    showsub = false;
    toolbarModules = {
        toolbar: [
            ['bold', 'italic'],
            [{ 'color': [] }],
            ['underline', 'strike'],
            ['code-block', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            [{ 'align': [] }]
        ]
    };
    dropdownSettings: any = {}
    showSearch = true;
    selection: any[];
    selectedcustomers: any = {};
    selectedItems: Set<number> = new Set();
    showtemplate = false
    showmessagebox = false;
    selectedIndex: number;
    environmentValue: any = {}
    discomplex = true
    complexList1
    selectedRow: any;
    isSmsForAdminChecked: boolean = false;
    adminMobileNumbers: string[] = [];
    roleId: any;
    masterChecked: boolean = false;

    constructor(private fb: FormBuilder, private lookupDataService: LookupDataServiceService, private navigation: NavigationService,
        private cdr: ChangeDetectorRef, private toast: NotificationService, private bulkMessageService: BulkMessageService, private userDataService: UserdataService
    ) {
        this.environmentValue = environment
    }

    ngOnInit(): void {
        // Initialize groupForm
        this.groupForm = this.fb.group({
            serviceProvider: [null],
            applicationStatus: [22],
            city: [null],
            complex: [null],
            cityText: [],
            mobileNumber: []
        });

        // Call initialization methods
        this.init();
        this.getlookupData();

        // Configure dropdown settings
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'value',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            itemsShowLimit: 1,
            closeDropDownOnSelection: true
        };

    }

    init() {
        this.groupForm.get('cityText')?.disable();



        this.userdetailsForm = this.fb.group({
            fullName: [null],
            messagetrix: [null],
            mobileNumber: [null],
            email: [null],
            refrenceNumber: [null]
        })
        this.userdetailsForm.disable()
        this.groupMessageForm = this.fb.group({
            message: [null, Validators.required],
            subject: [null, Validators.required],
            messageNotificationType: ["1"],
            email: [null, Validators.required],
            categoryType: ["4"],
            template: [null]

        })
        this.singleMessageForm = this.fb.group({
            Recipent: [{ value: null, disabled: true }, Validators.required],
            messageNotificationType: ["1"],
            message: ['', Validators.required],
            subject: [null, Validators.required]
        })
        this.searchform = this.fb.group({
            searchQuery: [null],
        })


    }

    onTabChange(event: MatTabChangeEvent) {
        this.selectedIndex = event.index;
        this.reset()
    }
    counttext() {
        if (this.singleMessageForm.value.message) {
            let value = this.singleMessageForm.value.message
            this.messageCount = value.length;
        }
        else {
            let value = this.groupMessageForm.value.message
            this.messageCount = value.length;
        }
    }
    // handleKeyDown(event: KeyboardEvent): void {
    //     if (event.key === 'Enter') {
    //         console.log(event);
    //         const delta = this.singleMessageForm.value.message // Get the Delta format

    //         // Convert Delta to HTML
    //         // const htmlContent = delta.getHTML();
    //         // console.log(htmlContent)
    //         return; // Just return and let the editor handle the line break
    //     }
    // }


    getlookupData() {
        this.lookupDataService.getApplicationStausType()
            .pipe(
                map(res => res ? [...res].filter((x: any) => x.key === 22) : [])
            )
            .subscribe(res => {
                this.applicationStatusList = res;
                this.filteredList2 = this.applicationStatusList.slice()
                if (res.length > 0) {
                    this.applicationStatus = res[0].key;
                }
            });

        // Get service provider for all
        this.lookupDataService.getServiceProviderForAll()
            .pipe(
                map(res => res
                    ? [...res].filter((x: any) =>
                        x.value?.trim().toLowerCase() !== 'all')
                        .sort((a: any, b: any) => a.value.localeCompare(b.value))
                    : []
                )
            )
            .subscribe(res => {
                this.serviceProviderList = res;
                this.filteredList1 = this.serviceProviderList.slice();
            });

        // Get province list
        this.lookupDataService.getProvince()
            .pipe(
                map(res => res ? [...res].sort((a: any, b: any) => a.value.localeCompare(b.value)) : [])
            )
            .subscribe(res => {
                this.provinceList = res;
                this.filteredList3 = this.provinceList.slice()

                // Set a timeout and manually trigger change detection
                setTimeout(() => {
                    this.isReset = false;
                    this.cdr.detectChanges();
                }, 200);
            });

        // Get complex application list
        this.lookupDataService.getComplexApplication().subscribe(res => {
            if (res) {
                this.complexApplicationList = res;
                // this.filteredList4 = this.complexApplicationList.slice()
            }
        });
    }

    onChangeServiceProvider() {
        if (this.complexApplicationList.length > 0) {
            if (this.groupForm.value.serviceProvider) {
                this.complexList = [];
                this.isDisableCity = false;
                this.showmessagebox = false


                this.groupForm.get('complex').setValue(null)
                this.complexList = this.complexApplicationList
                    .filter((item: any) => item.serviceProviderId === this.groupForm.value.serviceProvider)
                    .map((item: any, index) => ({
                        id: index,
                        key: item.serviceProviderId,
                        value: item.complexName
                    }));

            }

            if (this.complexList.length > 0) {
                this.complexList = this.complexList
                    .sort((a, b) => a.value.localeCompare(b.value));
                this.filteredList4 = [...this.complexList]
                this.complexList1 = this.complexList
                console.log(this.complexList);


            }

            if (this.groupForm.value.serviceProvider) {
                if (this.groupForm.value.serviceProvider == -1) {

                    this.isDisableCity = true;
                    this.showSearch = false;
                    this.showmessagebox = true
                    //   this.city = undefined;
                    this.complex = undefined;
                    //   this.cityText = undefined;
                    //   this.groupMessage.applicationList = [];

                    const tempParams = {
                        customerName: null,
                        email: null,
                        mobileNumber: null,
                        customerReferenceNumber: null,
                        address: null,
                        serviceproviderId: -1,
                        // roleId : null
                    };

                    this.applicationList.push(tempParams);
                }
                else {
                    this.isDisableCity = false;
                    this.showSearch = true;
                }
            }
            else {
                //   this.isDisableCity = false;
                //   this.showSearch = true;
                this.applicationList = [];
            }
        }
    }
    getSelectedCount() {
        const selectedItems = this.groupForm.get('complex')?.value;
        return selectedItems ? selectedItems.length + 1 : 0;
    }
    oncitychange() {
        const selectedComplex = this.groupForm.value.complex; // Get the selected complex value

        if (selectedComplex && selectedComplex.length > 0) { // Check if something is selected
            this.groupForm.get('cityText')?.disable();
        } else {
            this.groupForm.get('cityText')?.enable(); // Enable the cityText field
        }
    }
    typecity() {
        console.log('hit');

        if (this.groupForm.value.cityText)
            this.complexList = []

        else
            this.complexList = this.complexList1
    }
    oncomplexchange() {
        const selectedComplex = this.groupForm.value.complex;
        console.log(selectedComplex);
        this.complex = [...selectedComplex]
        // Get the selected complex value
        if (selectedComplex && selectedComplex.length > 0) { // Check if something is selected
            this.groupForm.get('cityText')?.disable();
        } else if (this.groupForm.value.city) {
            this.groupForm.get('cityText')?.enable(); // Enable the cityText field
        }
    }
    goToBack() {
        this.navigation.gotoManageSms();
    }
    reset() {
        this.selectedItems.clear();
        this.masterChecked = false;

        this.init()
        this.isDisableServiceProvider = false
        this.groupForm.reset()
        this.groupForm.get('applicationStatus').setValue(22)
        this.data = [];
        this.dataSource = new MatTableDataSource(this.data);
        this.showmessagebox = false
        this.showmessage = false;
        this.messageCount = 0
        this.complex = null
        this.complexList = null;
        this.showsub = false;
        this.adminMobileNumbers = [];
        this.isSmsForAdminChecked = false;

    }
    smsormail(event: any) {
        if (event.value == 2) {
            this.singleMessageForm.get('Recipent').setValue(this.userdetailsForm.value.email)
            this.showsub = true;
            this.singleMessageForm.patchValue({ message: null })
        }
        else {
            this.singleMessageForm.get('Recipent').setValue(this.userdetailsForm.value.mobileNumber)
            this.singleMessageForm.patchValue({ message: null })
            this.singleMessageForm.value.message = null

            this.showsub = false;
        }

    }
    singleMessageSend(): void {
        let message: any = {}
        let userdetailsForm = this.userdetailsForm.getRawValue()
        message.fullName = userdetailsForm.fullName;
        message = { ...message, ...this.singleMessageForm.value };
        message.messageNotificationType = parseInt(this.singleMessageForm.value.messageNotificationType)


        // Validate email notifications
        if (message.messageNotificationType === this.BulkMessageNotificationTypeEnum.Email) {
            // message.message = toHTML(this.singleMessageForm.get('message')?.value); //temp gunal
            message.message = this.singleMessageForm.get('message')?.value

            if (!message.subject) {
                this.toast.showError('Please enter subject')
                return;

            }
        }

        // If banking details request is made, set contact details
        if (this.showmessage) {
            let userdetailsForm = this.userdetailsForm.getRawValue()
            message.mobileNumber = userdetailsForm.mobileNumber;
            message.email = userdetailsForm.email;
            message.message = 'Please Update Bank Details.';
        }

        // Validate message content
        if (!message.message) {
            this.toast.showError('Please enter message content')
            return;
        }
        message.requestBank = this.showmessage
        message.isBankInfoRequested = this.showmessage;

        // For SMS notification, append system signature
        if (message.messageNotificationType === this.BulkMessageNotificationTypeEnum.Sms) {
            delete message.subject
            // message.Recipent=this.userdetailsForm.value.email
            message.message += '-Home Connect System';
        }

        // Call the service to send the message
        this.bulkMessageService.singleMessage(message).subscribe(res => {
            // Handle different responses
            if (res === this.environmentValue.RequestBankingDetails.SingleMessageSent) {
                this.toast.showSuccess('Message sent successfully');
                this.userdetailsForm.reset(); // Assuming you're using reactive forms
                this.reset(); // Reset your component state
                this.goToBack(); // Navigate back or handle UI reset
            }

            if (res === this.environmentValue.RequestBankingDetails.RequestBankingDetails) {
                this.toast.showSuccess('Banking detail update request sent successfully.');
                this.userdetailsForm.reset();
                this.reset();
                this.goToBack();
            }
        });
    }

    async groupMessageSend(): Promise<boolean> {
        console.log(this.groupMessageForm.value);


        // Validate subjectl

        if (!this.groupMessageForm.value.subject) {
            this.toast.showError("Please enter subject");
            return false;
        }



        // Validate message content
        if (!this.groupMessageForm.value.message) {
            this.toast.showError("Please enter message content");
            return false;
        }

        // SMS-specific handling
        if (this.groupMessageForm.value.messageNotificationType === this.BulkMessageNotificationTypeEnum.Sms.toString()) {
            this.groupMessageForm.value.message = this.groupMessageForm.value.message + "-Home Connect System";
        }

        try {
            let groupmessage: any = {
                categoryType: parseInt(this.groupMessageForm.value.categoryType),
                message: this.groupMessageForm.value.message,
                messageNotificationType: parseInt(this.groupMessageForm.value.messageNotificationType),
                subject: this.groupMessageForm.value.subject,
                messagetrix: '',
                // roleId : this.roleId
            }
            if (this.groupForm.value.serviceProvider == -1)
                groupmessage.applicationList = [...this.applicationList]
            else
                groupmessage.applicationList = [...this.data.filter((item) => this.selectedItems.has(item.id))]
            if (this.groupMessageForm.value.categoryType != '4') {
                const selectedTemplate = this.templateList.find(
                    x => x.key == this.groupMessageForm.value.template
                );
                groupmessage.template = { ...selectedTemplate }
            }
            console.log(groupmessage);
            groupmessage.applicationList = [
                ...this.applicationList,
                ...this.data.filter(item => this.selectedItems.has(item.id))
            ].map(x => ({
                ...x,
                mobileNumber: '+27' + (x.mobileNumber || '').replace(/^(\+27|27|0)/, '')
            }));
            // Send the bulk message
            await this.bulkMessageService.bulkMessage(groupmessage).subscribe((res) => {

                // Handle response
                if (res === this.environmentValue.RequestBankingDetails.BulkMessagesSent) {
                    this.toast.showSuccess("Message sent successfully");
                    this.goToBack();
                } else if (res === this.environmentValue.RequestBankingDetails.CannotFindServiceProviderUserList) {
                    this.toast.showError("The message cannot be sent. User not found.");
                    this.goToBack();
                }
            });


        }
        catch (error) {
            this.toast.showError("Error sending group message:", error);
            return false;
        }

        return true;
    }

    async searchUser(): Promise<boolean> {

        this.selectedUser = 0;
        let searchText = this.searchform.value.searchQuery;
        if (searchText) {
            this.userdetailsForm.reset()

            try {
                await this.userDataService.getUserDetails(searchText).subscribe((res) => {

                    if (res) {
                        this.userDetailsList = [...res];
                        this.dataSource = new MatTableDataSource(this.userDetailsList)
                        if (this.userDetailsList.length === 1) {
                            this.selectedUser = 1;
                            this.selectedUserClick(this.userDetailsList[0]);
                            return true;
                        }

                        return true;
                    } else {
                        this.toast.showError("Nothing Found!");
                        return false;
                    }
                });

            } catch (error) {
                this.toast.showError("Error fetching user details:", error);
                return false;
            }
        } else {
            this.toast.showError("Enter Search Value");
            return false;
        }

        return true;
    }

    selectedUserClick(user: any): void {
        if (user) {
            this.selectedRow = user;
            this.userdetailsForm.patchValue(user)
            this.singleMessageForm.get('Recipent').setValue(user.mobileNumber);
            this.showmessagebox = true;
        }
    }

    requestBankChange(index) {
        if (index.checked) {
            this.showmessage = true;
        }
        else
            this.showmessage = false;
    }

    categoryType() {
        this.groupMessageForm.patchValue({ message: '' })
        this.messageCount = 0
        let categoryType = parseInt(this.groupMessageForm.value.categoryType)
        if (categoryType != this.categoryTypeEnum.New) {
            this.lookupDataService.getTemplateList(this.groupMessageForm.value.categoryType, this.groupMessageForm.value.messageNotificationType).subscribe((result) => {
                if (result) {
                    this.templateList = result;
                    this.showtemplate = true
                }
            });
        }
        else {
            this.showtemplate = false
            this.groupMessageForm.get('message').setValue('')
        }
    }

    selectTemplate() {
        if (this.groupMessageForm.value.template) {
            this.bulkMessageService.getTemplateContent(this.groupMessageForm.value.template).subscribe((res) => {
                if (res.result) {
                    this.groupMessageForm.patchValue({ message: res.result.content })
                    this.messageCount = res.result.content.length;
                }
            });
        }
    }

    Onchange(): void {
        if (!this.isReset) {
            const postdata: any = {};
            console.log(this.groupForm.value);
            if (this.groupForm.value.serviceProvider) {
                if (!this.isDisableServiceProvider && !this.isDisableCity) {
                    this.isDisableServiceProvider = true;
                }
                postdata.serviceProviderId = this.groupForm.value.serviceProvider;
            }

            if (this.groupForm.value.city) {
                if (!this.isDisableServiceProvider && !this.isDisableCity) {
                    this.isDisableCity = true;
                }
                postdata.city = this.groupForm.value.city;
            }

            if (this.applicationStatus) {
                postdata.applicationStatus = this.applicationStatus;
            }

            if (this.groupForm.value.cityText) {
                this.complex = [];
                postdata.cityText = this.groupForm.value.cityText;
            }
            if (this.adminMobileNumbers && this.adminMobileNumbers.length > 0)
                postdata.mobileNumber = this.adminMobileNumbers

            if (this.complex && this.complex.length > 0) {
                this.groupForm.patchValue({ cityText: '' })
                this.selectedComplexList = [];
                this.complexList.forEach((item1: any) => {
                    this.complex.forEach((item2: any) => {
                        if (item1.id === item2.id) {
                            this.selectedComplexList.push(item1.value);
                        }
                    });
                });

                postdata.complex = this.selectedComplexList;
            }

            this.bulkMessageService.getMessagingUserDetailsBySPIdandCity(postdata).subscribe((result: any) => {
                if (result && result.length > 0) {
                    this.serviceProviderUserDetailsList = result; // Replaces angular.copy
                    this.data = result.map((item, index) => ({
                        ...item,
                        id: index + 1, // You can change this logic as needed
                    }));
                    this.dataSource = new MatTableDataSource(this.data)
                    this.selection = new Array(this.serviceProviderUserDetailsList.length).fill(false);

                    this.dataSource.paginator = this.paginator;
                    console.log(this.data);


                    if (!this.groupForm.value.city) {
                        let tempCityList = Array.from(new Set(result.map((x: any) => x.city)));
                        this.cityList = tempCityList.map(val => ({ key: val, value: val }));
                        this.cityList.sort((a: any, b: any) => a.value.localeCompare(b.value));
                    }

                    if (!this.groupForm.value.serviceProvider) {
                        let tempServiceProviderIdList = Array.from(new Set(result.map((x: any) => x.serviceProviderId)));
                        const tempServiceProviderList = [...this.serviceProviderList];

                        this.serviceProviderList = tempServiceProviderList.filter((val: any) =>
                            tempServiceProviderIdList.includes(val.key)
                        );
                    }
                }
                else {
                    debugger
                    this.dataSource = new MatTableDataSource(result)
                    this.dataSource.paginator = this.paginator;
                }
            });
        }

    }


    toggleAllCheckboxes(event: MatCheckboxChange) {
        const checked = event.checked;
        this.data.forEach((item) => {
            if (checked) {
                this.selectedItems.add(item.id);
                this.showmessagebox = this.selectedItems.size > 0;

            } else {
                this.selectedItems.delete(item.id);
                this.showmessagebox = false;

            }
        });
    }

    onCheckboxChange(item: any) {
        if (this.selectedItems.has(item.id)) {
            this.selectedItems.delete(item.id);
        } else {
            this.selectedItems.add(item.id);
        }
        this.showmessagebox = this.selectedItems.size > 0;
    }

    isSelected(item: any): boolean {
        return this.selectedItems.has(item.id);
    }

    onlyNumbersWithZero(event: KeyboardEvent): void {
        const input = event.target as HTMLInputElement;
        const key = event.key;
        if (key.length > 1) {
            return;
        }
        if (!/^[0-9]$/.test(key)) {
            event.preventDefault();
            return;
        }
    }

    CheckboxSmsAdmin(event: MatCheckboxChange) {
        this.isSmsForAdminChecked = event.checked;
    }

    addAdmin() {

        let number = this.groupForm.get('mobileNumber')?.value?.trim();
        if (!number) {
            this.toast.showWarning("Please enter the mobile number")
        }
        number = number.replace('+27', '');
        if (number.startsWith('0')) {
            number = number.substring(1);
        }
        number = `+27${number}`;
        if (this.adminMobileNumbers.includes(number)) {
            this.toast.showWarning('Mobile Number already added');
            return;
        }
        this.adminMobileNumbers.push(number);
        console.log(this.adminMobileNumbers);
        this.groupForm.get('mobileNumber')?.reset();
    }

    resetAdmin() {
        this.adminMobileNumbers = [];
    }
    preventLeadingSpace(event: Event) {
        const e = event as KeyboardEvent;
        const input = e.target as HTMLInputElement;

        if (e.key === ' ' && input.selectionStart === 0) {
            e.preventDefault();
        }
    }

}

